import React from 'react';
import DialogComponent from '@ui/components/Dialog/Dialog.component';
import useDictionary from '@ui/hooks/useDictionary';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    groupName,
    serverError,
    onConfirmClick,
    onBtnKeyDown,
    onCancelClick,
}: IProps) => {
    const getWord = useDictionary();

    return (
        <>
            <DialogComponent
                className="group-delete"
                alertText={serverError ? 'serverError' : undefined}
                loading={loading}
                lang={lang}
                title={`${getWord(
                    'confirmGroupDeleteWarning',
                )} "${groupName}"?`}
                text={`(${getWord('confirmGroupDeleteWarningText')})`}
                onConfirmClick={onConfirmClick}
                onCancelClick={onCancelClick}
                onBtnKeyDown={onBtnKeyDown}
            />
        </>
    );
};

const GroupDeleteComponent = React.memo(Component);

export default GroupDeleteComponent;
